import Alert from './Alert'
export default class SuccessAlert extends Alert{
    show() {
        swal({
            title: this.key('title', uLang('app.success')),
            text: this.key('text'),
            icon: "success",
            button: this.key('button', uLang('app.close')),
            closeOnClickOutside: false,
            closeOnEsc: false,
            timer: this.key('timer', 0)
        })
    }
}
